module.exports = __webpack_public_path__ + "static/media/Glazbeno-scenki prikaz-foto 4 .4a68d95f.png";